import React from "react"
import { Col, Row, Form, Input, FormFeedback } from "reactstrap"
import Select from "react-select"
import { customStylesSelect } from "common/data/settings"
const HeaderWeebHook = ({
  validation,
  webhookListdata,
  selectedWebHookData,
  removeWebhookData,
}) => {
  return (
    <div>
      <Form
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <Row form>
          <Col lg={3}>
            <div className="mb-3">
              <Select
                id="processname"
                name="processname"
                placeholder="Please Select Process Name"
                onBlur={validation.handleBlur}
                value={validation?.values?.processname}
                onChange={value => {
                  validation.setFieldValue("processname", value)
                }}
                styles={customStylesSelect}
                invalid={
                  validation.touched.processname &&
                  validation.errors.processname
                    ? true
                    : false
                }
                options={(webhookListdata || [])?.map(el => ({
                  ...el,
                  label: el?.processname,
                  value: el?.id,
                }))}
                classNamePrefix="select2-selection"
              />
              {validation.touched.processname &&
              validation.errors.processname ? (
                <div className="invalid-custom">
                  {validation.errors.processname}
                </div>
              ) : null}
            </div>
          </Col>
          <Col lg={5}>
            <div className="mb-3">
              <div className="mb-3">
                <Input
                  id="webhookurl"
                  name="webhookurl"
                  className="form-control"
                  placeholder="Enter WebHook Url"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.webhookurl || ""}
                  invalid={
                    validation.touched.webhookurl &&
                    validation.errors.webhookurl
                      ? true
                      : false
                  }
                />
                {validation.touched.webhookurl &&
                validation.errors.webhookurl ? (
                  <FormFeedback type="invalid">
                    {validation.errors.webhookurl}
                  </FormFeedback>
                ) : null}
              </div>
            </div>
          </Col>
          {selectedWebHookData?.id && (
            <Col lg={1}>
              <div className="text-start">
                <button
                  className="btn btn-danger save-user me-2 mb-3"
                  onClick={removeWebhookData}
                  style={{ width: "100%" }}
                >
                  Cancel
                </button>
              </div>
            </Col>
          )}
          <Col lg={1}>
            <div className="text-start">
              <button
                type="submit"
                className="btn btn-primary save-user me-2 mb-3"
                style={{ width: "100%" }}
              >
                Save
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  )
}
export default HeaderWeebHook
